import React from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { c } from 'ttag'
import YumSmallSelect from '../YumSmallSelect/YumSmallSelect'
import { isRtl } from '../../i18nInit'
import YumMediumSelect from '../YumMediumSelect/YumMediumSelect'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      display: 'inline-block',
      lineHeight: '1',
      verticalAlign: 'bottom',
    },
  }),
)

export interface IYumAvgSumFilterProps {
  groupSum: boolean
  setGroupSumFilter(groupSum: boolean): any
  isNewLayout?: boolean
}

export default function YumAvgSumFilter(props: IYumAvgSumFilterProps) {
  const classes = useStyles()
  const [groupSum, setGroupSum] = React.useState(props.groupSum)

  const handleGroupSumChange = (event: React.ChangeEvent<any>) => {
    const { value } = event.target as { value: string }
    const val = value === 'true'
    setGroupSum(val)
    props.setGroupSumFilter(val)
  }

  const Component = props.isNewLayout ? YumMediumSelect : YumSmallSelect

  return (
    <div className={classes.root}>
      <Component
        style={
          isRtl
            ? {
                marginRight: '10px',
              }
            : {
                marginLeft: '10px',
              }
        }
        color="primary"
        value={groupSum + ''}
        onChange={handleGroupSumChange}
      >
        <option value={'false'}>{c('short').t`AVG`}</option>
        <option value={'true'}>{c('short').t`SUM`}</option>
      </Component>
    </div>
  )
}
